<template>
    <div class="columnConfigContainer">
        <div class="columnMain">
            <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="value"
                    filterable
                    :filter-placeholder="$t('ems.PleaseEnterTAGNumber')" 
                    :titles="[$t('ems.ColumnsNotDisplayedExported'), $t('ems.DisplayedExportedColumns')]"  
                    :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
                    @change="handleChange"
                    :data="data">
                <div slot-scope="{ option }" class="tagItem">
                    <div style="width: 60px">{{ "#" + option.ordNum }}</div>
                    <div>{{ option.label }}</div>
                    <div class="tagItemAction">
                        <el-button @click.native.prevent="openEdit(option)" type="text" size="medium" icon="el-icon-edit" >{{ $t('ems.edit') }}</el-button>
                        <el-button @click.native.prevent="openDict(option)" type="text" size="medium" icon="el-icon-c-scale-to-original" >{{ $t('ems.dictionaryMaintenance') }}</el-button>
                    </div>
                </div>
            </el-transfer>
        </div>
        <template v-if="editVis">
            <el-dialog :title="$t('ems.edit')" :visible.sync="editVis" append-to-body width="500px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent :model="form" :rules="rules" class="tableSearchForm" style="width: 400px; margin-left: 30px" size="small" ref="editForm">
                    <el-form-item :label="$t('ems.TAGNumber')"> 
                        <el-input v-model="form.tagNo" disabled></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('ems.tagAliasName')" prop="tagAliasName">
                        <el-input v-model="form.tagAliasName" maxlength="300" ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('ems.unit')">
                        <el-input v-model="form.unit" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('ems.ordNum')" prop="ordNum">
                        <el-input v-model="form.ordNum" oninput="value=value.replace(/[^\-?\d.]/g,'')"  :placeholder="$t('ems.TheLargerSortingTip')"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="editVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="handleEdit">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </template>
        <template v-if="dictVis">
            <el-dialog :title="$t('ems.dictionaryMaintenance')" :visible.sync="dictVis" append-to-body width="800px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <div style="display: flex;  width: 100%">
                    <el-form @submit.native.prevent :model="dictForm"  :rules="dictRules" ref="dictForm" size="small" label-width="80px" class="tableSearchForm" style="width: 240px; margin-left: 10px; margin-right: 20px; background: #252525; padding: 40px 40px 40px 10px">
                        <el-form-item :label="$t('ems.TAGNumber')">
                            <el-input v-model="dictForm.tagNo" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('ems.dictKey')" prop="dictKey">
                            <el-input v-model="dictForm.dictKey" maxlength="300" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('ems.dictName')" prop="dictName">
                            <el-input v-model="dictForm.dictName" maxlength="50"></el-input>
                        </el-form-item>
                        <div style="margin-top: 40px; text-align: right">
                            <el-button size="small" type="primary" @click="handleDictAdd" :loading="dictAddLoading">{{ $t('ems.add') }}</el-button>
                        </div>
                    </el-form>
                    <el-table :data="activeRowTagDictList" v-loading="listLoading" border size="mini" height="320" class="BMSTable tagDictList" style="width: 320px">
                        <el-table-column :label="$t('ems.dictKey')" prop="dictKey"></el-table-column>
                        <el-table-column :label="$t('ems.dictName')" prop="dictName"></el-table-column>
                        <el-table-column :label="$t('ems.operate')" width="100">
                            <template slot-scope="scope">
                                <el-button  type="text" style="border: none"  @click.native.prevent="handleDictDelete(scope.row.id)" size="small" icon="el-icon-delete">{{ $t('ems.alarm.remove') }}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dictVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                </div>
            </el-dialog>
        </template>

    </div>
</template>

<script>
    import { GetDeviceExportConfig, setDeviceDisplay,getDeviceConfigTagById, updateDeviceConfig, removeTagListDict, addTagListDict, getTagListDict } from "@/api/spms";
    import i18n from "@/lang";

    export default {
        name: "columnConfig",
        data() {
            return {
                data: [],
                value: [],
                form: {
                    unit: '',
                },
                activeRow: null,
                editVis: false,
                dictVis: false,
                rules: {
                    tagAliasName: [
                        { required: true, message: i18n.t("ems.PleaseEnterTAGName"), trigger: 'blur' }, 
                    ],
                    ordNum: [
                        { required: true, message: i18n.t("ems.PleaseEnterTAGSequenceNumber"), trigger: 'blur' }, 
                    ],
                },
                activeRowTagDictList: [],
                dictAddLoading: false,
                dictForm: {
                },
                dictRules: {
                    dictKey: [
                        { required: true, message: i18n.t("ems.PleaseEnterDictionaryKeyValue"), trigger: 'blur' }, 
                    ],
                    dictName: [
                        { required: true, message: i18n.t("ems.PleaseEnterDictionaryName"), trigger: 'blur' }, 
                    ],
                }
            };
        },
        methods: {
            handleChange(value, direction, movedKeys) {
                setDeviceDisplay({displayFlag: direction == 'right' ? 1 : 0 , ids: movedKeys.join(',')}).then(res => {
                    if(res && res.data && res.data.success){
                        this.$message.success(i18n.t("ems.SuccessfulOperation")) 
                    }else{
                        this.$message.success(i18n.t("ems.operationFailed")) 
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.success(i18n.t("ems.operationFailed"))
                })
            },
            async initData() {
                const params1 = {current: 1, size: 5000, deviceType: this.$parent.form.device[0], displayFlag: 0};
                const params2 = {current: 1, size: 5000, deviceType: this.$parent.form.device[0], displayFlag: 1};
                const res1 = await GetDeviceExportConfig(params1);
                const temp1 = res1.data.data.records || [];
                const list1 = temp1.map(i => {
                    return {key: i.id, label: i.tagNo + '-' + i.tagAliasName, ordNum: i.ordNum}
                });

                const res2 = await GetDeviceExportConfig(params2);
                const temp2 = res2.data.data.records || [];
                const list2 = temp2.map(i => {
                    return {key: i.id, label: i.tagNo + '-'+i.tagAliasName, ordNum: i.ordNum}
                });
                this.data = list1.concat(list2);
                this.value = list2.map(i => i.key);
                console.log(this.data, this.value)
            },
            handleEdit(){
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        updateDeviceConfig({ ...this.form }).then(res => {
                            this.editVis = false;
                            if(res && res.data && res.data.success){
                                this.$message.success(i18n.t("ems.SuccessfulOperation"));
                                const index = this.data.findIndex(i => i.key  === this.form.id);
                                this.$set(this.data, index, {key: this.form.id, label: this.form.tagNo + '-'+this.form.tagAliasName, ordNum: this.form.ordNum});
                                this.$forceUpdate();
                                console.log(this.data[index])
                            }else{
                                this.$message.success(i18n.t("ems.operationFailed"))
                            }
                        }).catch(err => {
                            console.log(err);
                            this.editVis = false;
                            this.$message.success(i18n.t("ems.operationFailed"))
                        })
                    } else {
                        return false;
                    }
                });
            },
            openEdit(row){
                this.activeRow = row;
                getDeviceConfigTagById(row.key).then(res => {
                    this.editVis = true;
                    this.form = res.data.data || {};
                });
            },

            openDict(row){
                this.activeRow = row;
                const temp = row.label.split('-');
                getTagListDict(temp[0]).then(res => {
                    console.log(res);
                    this.activeRowTagDictList = res.data.data || [];
                    this.dictVis = true;
                    this.dictForm = { dictKey: '', dictName: '', tagNo: temp[0]}
                });
            },
            handleDictAdd(){
                this.$refs['dictForm'].validate((valid) => {
                    if (valid) {
                        this.dictAddLoading = true;
                        addTagListDict({ ...this.dictForm }).then(res => {
                            this.dictAddLoading = false;
                            if(res && res.data && res.data.success){
                                this.$message.success(i18n.t("ems.SuccessfulOperation"));
                                this.dictForm = { dictKey: '', dictName: '', tagNo:this.dictForm.tagNo }
                                getTagListDict(this.dictForm.tagNo).then(res1 => {
                                    this.activeRowTagDictList = res1.data.data || [];
                                });
                            }else{
                                this.$message.error(i18n.t("ems.operationFailed"))
                            }
                        }).catch(err => {
                            console.log(err);
                            this.dictAddLoading = false;
                            this.$message.error(i18n.t("ems.operationFailed"))
                        })
                    } else {
                        return false;
                    }
                });
            },
            handleDictDelete(id){
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), i18n.t("ems.alarm.promptTip"), {
                    confirmButtonText: i18n.t("ems.alarm.confirmTip"),
                    cancelButtonText: i18n.t("ems.alarm.cancelTip"),
                    closeOnClickModal: false,
                    type: 'warning',
                }).then(() => {
                    removeTagListDict(id).then(res => {
                        if (res && res.data && res.data.success) {
                            this.$message.success(i18n.t("ems.alarm.OperationSuccessfulTip"));
                            getTagListDict(this.dictForm.tagNo).then(res1 => {
                                this.activeRowTagDictList = res1.data.data || [];
                            });
                        } else {
                            this.$message.error(i18n.t("ems.alarm.OperationFailedTip"));
                        }
                    }).catch(err => {
                        this.$message.error(err)
                    });
                });
            }
        },
        mounted() {
            this.initData();
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/site";
    .columnConfigContainer{
        height: 100%;
        box-sizing: border-box;
        padding: 0 30px;
        .columnMain{
            background-color: var(--table_header);
            height: 750px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
<style lang="scss">
    .columnConfigContainer{
        .el-transfer-panel__item .el-checkbox__input {
            position: absolute;
            top: 8px;
        }
        .el-transfer-panel__header{
            height: 40px;
            line-height: 40px;
            background: #343434;
            margin: 0;
            padding-left: 15px;
            border-bottom: 1px solid #292929;
            box-sizing: border-box;
            color: #a9a9a9;
            .el-checkbox{
                .el-checkbox__label{
                    color: #e9e9e9;
                }
            }
        }
        .el-transfer-panel{
            border: 1px solid #151515;
            border-radius: 4px;
            overflow: hidden;
            background: var(--dataItemPanle);
            display: inline-block;
            vertical-align: middle;
            width: 640px;
            height: 700px;
            max-height: 100%;
            box-sizing: border-box;
            position: relative;
        }
        .el-checkbox-group{
            height: 560px;
        }
        .tagItem{
            font-size: 16px;
            color: #9c9c9c;
            display: flex;
            align-items: center;
            /*justify-content: space-between;*/
            position: relative;
            .tagItemAction{
                position: absolute;
                right: 0;
                height: 100%;
                top: 0;
                font-size: 14px;
                .el-button--text {
                    color: rgb(68, 205, 234);
                }
            }
        }

        .el-transfer-panel__filter .el-input__inner {
            font-size: 16px;
        }

        .el-input__inner {
            background-color: #5f5f5f;
            border: 1px solid #494949;
            color: #e9e9e9;
        }
        .el-transfer__buttons{
            .el-transfer__button{
                display: block !important;
            }
            .el-button+.el-button{
                margin-left: 0;
            }
        }
        .el-checkbox:last-of-type {
             margin-right: 30px;
        }
    }



     .tagDictList .el-table__header-wrapper thead th {
         font-size: 13px !important;
         height: 40px !important;
     }
</style>